@for (record of records; track record) {
  <div class="history-record">
    <div class="record-header">
      <oui-icon class="record-icon">{{ record.icon }}</oui-icon>
      <div class="record-title body-2">
        <span class="subtitle-2">{{ record.actionText }}</span>
        {{ record.header }}
      </div>
    </div>
    <div class="record-body">
      <div class="timeline-container">
        <div class="timeline"></div>
      </div>
      <div class="record-content">
        @if (record.fileMetadata?.fileId) {
          <a class="record-file" (click)="onFileLinkClick(record.fileMetadata)"
            >{{ record.fileMetadata?.fileName }}</a
            >
          }
          @if (record.bordereauId) {
            <a class="record-file" (click)="onBordereauLink(record.bordereauId)"
              >voir le bordereau n°{{ record.bordereauId }}</a
              >
            }
            @for (detail of record.details; track detail) {
              <div class="body-2">{{ detail }}</div>
            }
          </div>
        </div>
      </div>
    }
